import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Sinulla on {{length}} hälytystä',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Maksutiedot tarkastuksessa',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Maksutiedot onnistuivat',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Maksutiedoissa virhe',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'Stripe tarkistaa parhaillaan maksutietojasi. Tämä voi kestää jopa 48 tuntia.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Maksutietosi on vahvistettu onnistuneesti. Voit nyt vastaanottaa maksuja.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Tiedoissasi näyttäisi olevan virhe. Klikkaa tästä päivittääksesi tietosi.',
    },
  },
};
